<template>
  <div style="width: 100%">
    <div style="height: 8%;position:relative;display: flex">
      <div style="">
        项目状态：
        <el-select v-model="searchMore.type" placeholder="请选择" @change="onChangeType">
          <el-option label="全部" value=""></el-option>
          <el-option label="未上报" value="未上报"></el-option>
          <el-option label="已上报" value="已上报"></el-option>
          <el-option label="已驳回" value="已驳回"></el-option>
          <el-option label="已通过" value="已通过"></el-option>
          <el-option label="已退回" value="已退回"></el-option>
        </el-select>
      </div>
      <div style="margin-left: 10px">
        项目年份：
        <el-date-picker
          @change="getData"
          v-model="searchMore.selectyear"
          type="year"
          value-format='yyyy'
          placeholder="选择年">
        </el-date-picker>
      </div>
      <el-button type="danger" style="position: absolute;right: 10px;top: 10px" @click="onFound">创建项目</el-button>
    </div>
    <el-table
      :data="tableData"
      stripe
      style="width: 100%">
      <el-table-column
        prop="name"
        label="项目名称"
        width="280"
        align="center"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="grade"
        label="推荐等级"
        width="180"
        align="center"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="unit"
        label="推荐单位"
        align="center"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="awardtype"
        label="奖励类别"
        align="center"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="schedule"
        label="进度"
        align="center"
        show-overflow-tooltip>
        <template slot-scope="scope">
          <div @click="onShowFlow(scope.row)" style="cursor: pointer">
            <div v-if="scope.row.schedule=='已上报'" style="color:#409EFF ">{{ scope.row.schedule }}</div>
            <div v-if="scope.row.schedule=='已通过'" style="color:#67C23A ">{{ scope.row.schedule }}</div>
            <div v-if="scope.row.schedule=='已驳回'" style="color:#F56C6C ">{{ scope.row.schedule }}</div>
            <div v-if="scope.row.schedule=='已退回'" style="color:#E6A23C ">{{ scope.row.schedule }}</div>
            <div v-if="scope.row.schedule=='未上报'">{{ scope.row.schedule }}</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="people"
        label="参与人"
        align="center"
        width="280"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="address"
        label="操作"
        align="center"
        width="380">
        <template slot-scope="scope">
          <!--          已上报 1   草稿 0  结束 88-->
          <el-button v-if="scope.row.schedule=='未上报'||scope.row.schedule=='已退回'" type="primary" size="mini" @click="onEdit(scope.row)">编辑</el-button>
          <el-button v-if="scope.row.schedule=='未上报'||scope.row.schedule=='已退回'" type="danger" size="mini" @click="onDelete(scope.row)">删除</el-button>
          <el-button v-if="scope.row.schedule=='未上报'||scope.row.schedule=='已退回'" type="success" size="mini" @click="onSubmit(scope.row)">提交项目</el-button>
          <el-button v-if="scope.row.schedule=='已上报'||scope.row.schedule=='已通过'||scope.row.schedule=='已驳回'"   size="mini" @click="onExport(scope.row)">导出</el-button>
          <el-button v-if="scope.row.schedule=='已上报'||scope.row.schedule=='已通过'||scope.row.schedule=='已驳回'" type="warning" size="mini" @click="onRead(scope.row)">查看</el-button>
          <el-button v-if="scope.row.schedule=='已退回'" type="info" size="mini" @click="onShowOpinion(scope.row,'退回')">退回意见</el-button>
          <el-button v-if="scope.row.schedule=='已驳回'" type="info" size="mini" @click="onShowOpinion(scope.row,'驳回')">驳回意见</el-button>
        </template>
      </el-table-column>
    </el-table>
<!--    进度对话框-->
    <el-dialog
      title="进度详情"
      :visible.sync="dialogVisibleFlow"
      width="30%"
      :before-close="handleCloseFlow">
      <div>
        <el-timeline>
          <el-timeline-item v-for="(obj,index) in this.flowData" :key="obj.addtime" :timestamp="obj.submitdate||obj.checktime" placement="top">
            <el-card>
              <h4 v-if='obj.type=="提交申请"'>{{ obj.type }}</h4>
              <h4 >{{ obj.state }}</h4>
              <p v-if="obj.opinion">审核意见：{{ obj.opinion }}</p>
              <p>操作人：{{ obj.operator }}{{ obj.approver }}</p>
            </el-card>
          </el-timeline-item>
        </el-timeline>
      </div>
    </el-dialog>
<!--    审核意见对话框-->
    <el-dialog
      style="padding-top: 6%"
      :title="opinionTitle"
      :visible="dialogVisibleOpinion"
      width="30%"
      :before-close="handleCloseOpinion"
      :close-on-click-modal="false">
      <div style="padding:2vh 0 4vh 2.4vh;min-height: 15vh;">
        <span>{{opinionData}}</span>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import utils from "../js/utils";

export default {
  name: "AduitAward_Company",
  data() {
    return {
      searchMore: {
        type: '',
        selectyear: new Date().getFullYear().toString()
      },
      tableData: [],
      pageNum: 1,
      pageSize: 10,
      dialogVisibleFlow: false,
      flowData: [],
      dialogVisibleOpinion:false,
      opinionTitle:'',
      opinionData:'',
    }
  },
  methods: {
    onChangeType() {
      this.getData()
    },
    getData() {
      this.$axios({
        method: 'get',
        url: this.GLOBAL.URL + 'pingjiang/user/selectprojectfinish',
        params: {
          userid: sessionStorage.getItem('userid'),
          type: this.searchMore.type,
          selectyear: this.searchMore.selectyear,
        }
      }).then(res => {
        let resp = JSON.parse(utils.decrypt(res.data, 'sheyanyuan888@ab'));
        if (resp.code == 1000) {
          this.tableData = resp.data
        } else {
          this.showFailMsg(resp.message)
        }
      })
    },
    onFound() {
      this.$router.push({
        path: '/HomePage/PJGLHomepage/projectHomePage/PrimaryInfo_01'
      })
    },
    onEdit(row) {
      sessionStorage.setItem("pbcid", row.pbcid)
      this.$router.push({
        path: '/HomePage/PJGLHomepage/projectHomePage/PrimaryInfo_01',
      })
    },
    onDelete(row) {
      this.$axios({
        method: 'get',
        url: this.GLOBAL.URL + 'pingjiang/user/deleteproject',
        params: {
          pbcid: row.pbcid,
        }
      }).then(res => {
        let resp = JSON.parse(utils.decrypt(res.data, 'sheyanyuan888@ab'));
        if (resp.code == 1000) {
          this.showSuccessMsg(resp.message)
          this.getData()
        } else {
          this.showFailMsg(resp.message)
        }
      })
    },
    onRead(row) {
      sessionStorage.setItem("pbcid", row.pbcid)
      sessionStorage.setItem("openWith", 'readOnly')
      this.$router.push({
        path: '/HomePage/PJGLHomepage/projectHomePage/PrimaryInfo_01',
      })
    },
    onShowFlow(row) {
      if(row.schedule=='未上报'){
        return
      }
      this.dialogVisibleFlow = true
      this.$axios({
        method: 'get',
        url: this.GLOBAL.URL + 'pingjiang/common/selectprojectflow',
        params: {
          pbcid: row.pbcid
        }
      }).then(res => {
        let resp = JSON.parse(utils.decrypt(res.data, 'sheyanyuan888@ab'));
        if (resp.code == 1000) {
          this.flowData = resp.data
        } else {
          this.showFailMsg(resp.message)
        }
      })
    },
    handleCloseFlow() {
      this.dialogVisibleFlow = false
      this.flowData = []
    },
    onSubmit(row){
      this.$confirm('确认后项目将提交至专家评审，请确认信息填写无误! 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(()=>{
        this.$axios({
          method: 'get',
          url: this.GLOBAL.URL + 'pingjiang/user/addprojectfinish',
          params: {
            pbcid: row.pbcid,
            username: sessionStorage.getItem("username"),
          }
        }).then(res => {
          let resp = JSON.parse(utils.decrypt(res.data, 'sheyanyuan888@ab'));
          if (resp.code == 1000) {
            this.showSuccessMsg(resp.message)
            this.getData()
          } else {
            this.showFailMsg(resp.message)
          }
        })
      })
    },
    onExport(row){
      this.$axios({
        method: 'get',
        url: this.GLOBAL.URL + 'pingjiang/file/downprojectpdf',
        params:{
          pbcid:row.pbcid
        },
        responseType: 'blob'
      }).then(res => {
        const filename = row.name+'.docx';
        const blob = new Blob([res.data]);//处理文档流
        const alink = document.createElement('a');
        alink.style.display = 'none';
        alink.href = window.URL.createObjectURL(blob);
        alink.setAttribute('download', decodeURI(filename))
        document.body.appendChild(alink);
        alink.click();
        window.URL.revokeObjectURL(alink.href); // 释放URL 对象
        document.body.removeChild(alink);
      })
    },
    onShowOpinion(row,state){
      this.dialogVisibleOpinion = true
      if(state=='退回'){
        this.opinionTitle = '退回意见'
      }else if(state=='驳回'){
        this.opinionTitle = '驳回意见'
      }
      this.$axios({
        method: 'get',
        url: this.GLOBAL.URL + '/pingjiang/common/selectprojectflowopinion',
        params: {
          pbcid: row.pbcid,
          state:state
        }
      }).then(res => {
        let resp = JSON.parse(utils.decrypt(res.data, 'sheyanyuan888@ab'));
        if (resp.code == 1000) {
          this.opinionData = resp.data.opinion
        } else {
          this.showFailMsg(resp.message)
        }
      })

    },
    handleCloseOpinion() {
      this.dialogVisibleOpinion = false
      this.opinionData = ''
      this.opinionTitle = ''
    },
  },
  created() {
    sessionStorage.removeItem('pbcid');
    sessionStorage.removeItem('openWith');
    this.getData()
  }
}
</script>

<style scoped>
/deep/ .el-dialog__body {
  padding: 0;
  margin-right: 40px;
}
</style>



// WEBPACK FOOTER //
// src/views/PJGL/AduitAward_Company.vue